import React from "react";

export const BottleSVGComponent = () => (
    <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6H8" stroke="#242E35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.71429 8.36364V1H5.28571V8.36364L2.93029 10.1628C1.71057 11.0939 1 12.5045 1 13.996V23H13V13.996C13 12.5045 12.2894 11.0939 11.0697 10.1628L8.71429 8.36364Z"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
